import { render, staticRenderFns } from "./CartRecap.vue?vue&type=template&id=218beef8&scoped=true&"
import script from "./CartRecap.vue?vue&type=script&lang=js&"
export * from "./CartRecap.vue?vue&type=script&lang=js&"
import style0 from "./CartRecap.vue?vue&type=style&index=0&id=218beef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218beef8",
  null
  
)

export default component.exports